import { Component, Input, OnInit } from '@angular/core';
import { BlogService, TrackingService } from '@core/services';
import { environment } from '@env/environment';
import { take } from 'rxjs/operators';
import { BlogArticle, BlogArticleAdapter } from '@shared/models/blog-article.model';

@Component({
    selector: 'gh-category-section',
    templateUrl: 'category-section.component.html',
    standalone: false
})

export class CategorySectionComponent implements OnInit {
  @Input() category: any;
  articlesInCategory: BlogArticle[];

  constructor(
    private blogService: BlogService,
    private trackingService: TrackingService,
    private blogArticleAdapter: BlogArticleAdapter,
  ) { }

  ngOnInit() {
    this.getArticlesForCategory(this.category.id);
  }

  private getArticlesForCategory(categoryId: number) {
    this.blogService.getArticlesForCategory(categoryId)
      .pipe(take(1))
      .subscribe((res: any) => {
        if (res && !res.error) {
          const articles: BlogArticle[] = res.content || [];
          this.articlesInCategory = [];
          articles.forEach((article) => {
            this.articlesInCategory.push(this.blogArticleAdapter.adapt(article));
          });
          this.articlesInCategory = this.articlesInCategory.slice(0, 3);
        }
      });
  }


  navClick(postName: string, location: string) {
    this.trackingService.setDataLayerAttributes({
      event: 'interactionEvent',
      event_name: 'category_section_click',
      events: {
        post_name: postName,
        feature: 'blog',
        environment: environment.env,
        location
      }
    });
  }
}
